import { render, staticRenderFns } from "./FairBlackjack.vue?vue&type=template&id=0aa17faa&scoped=true"
import script from "./FairBlackjack.vue?vue&type=script&lang=js"
export * from "./FairBlackjack.vue?vue&type=script&lang=js"
import style0 from "./FairBlackjack.vue?vue&type=style&index=0&id=0aa17faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa17faa",
  null
  
)

export default component.exports